module.exports = __webpack_public_path__ + "static/media/greeting_card_3.0cf1934b.png";